export const _cookiesFr = {
    a: 'Ce site utilise des cookies qui sont indispensables à son fonctionnement.' +
        '\nCes cookies nous permettent d\'améliorer votre expérience sur nos sites.',
    b: 'En savoir plus sur l\'utilisation des cookies sur Alertes Spéciales.',
    c: 'En poursuivant la navigation, vous acceptez et autorisez leur utilisation.',
    btn: 'J\'ai compris',
};

export const _cookiesEn = {
    a: 'This site uses cookies which are essential for its operation. These cookies allow us to improve your experience on our sites.',
    b: 'Learn more about the use of cookies on Special Alerts.',
    c: 'By continuing to browse, you accept and authorize their use.',
    btn: 'Understood',
};

export const _cookiesDe = {
    a: 'Diese Website verwendet Cookies, die für ihren Betrieb unerlässlich sind. Diese Cookies ermöglichen es uns, Ihre Erfahrung auf unseren Websites zu verbessern.', //eslint-disable-line
    b: 'Erfahren Sie mehr über die Verwendung von Cookies auf Spezielle Warnungen.',
    c: 'Durch die weitere Nutzung der Website akzeptieren und genehmigen Sie deren Verwendung.',
    btn: 'Verstanden',
};
